/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type GetOauth2UiConfiguration200Response,
    GetOauth2UiConfiguration200ResponseFromJSON,
    GetOauth2UiConfiguration200ResponseToJSON,
} from '../models/GetOauth2UiConfiguration200Response';
import {
    type OAuthClientUIConfiguration,
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationToJSON,
} from '../models/OAuthClientUIConfiguration';
import {
    type PutOauth2UiConfiguration201Response,
    PutOauth2UiConfiguration201ResponseFromJSON,
    PutOauth2UiConfiguration201ResponseToJSON,
} from '../models/PutOauth2UiConfiguration201Response';

export interface GetOauth2UiConfigurationRequest {
    slashIDOrgID: string;
    oauthClientId: string;
}

export interface PutOauth2UiConfigurationRequest {
    slashIDOrgID: string;
    oauthClientId: string;
    slashIDRequiredConsistency?: PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum;
    slashIDRequiredConsistencyTimeout?: number;
    body?: OAuthClientUIConfiguration;
}

/**
 * 
 */
export class OAuth2Api extends runtime.BaseAPI {

    /**
     * Creates request options for getOauth2UiConfiguration without sending the request
     */
    async getOauth2UiConfigurationRequestOpts(requestParameters: GetOauth2UiConfigurationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getOauth2UiConfiguration().'
            );
        }

        if (requestParameters['oauthClientId'] == null) {
            throw new runtime.RequiredError(
                'oauthClientId',
                'Required parameter "oauthClientId" was null or undefined when calling getOauth2UiConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth2/clients/{oauth_client_id}/ui-configuration`;
        urlPath = urlPath.replace('{oauth_client_id}', encodeURIComponent(String(requestParameters['oauthClientId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */
    async getOauth2UiConfigurationRaw(requestParameters: GetOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOauth2UiConfiguration200Response>> {
        const requestOptions = await this.getOauth2UiConfigurationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOauth2UiConfiguration200ResponseFromJSON(jsonValue));
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */
    async getOauth2UiConfiguration(requestParameters: GetOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOauth2UiConfiguration200Response> {
        const response = await this.getOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putOauth2UiConfiguration without sending the request
     */
    async putOauth2UiConfigurationRequestOpts(requestParameters: PutOauth2UiConfigurationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling putOauth2UiConfiguration().'
            );
        }

        if (requestParameters['oauthClientId'] == null) {
            throw new runtime.RequiredError(
                'oauthClientId',
                'Required parameter "oauthClientId" was null or undefined when calling putOauth2UiConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (requestParameters['slashIDRequiredConsistency'] != null) {
            headerParameters['SlashID-Required-Consistency'] = String(requestParameters['slashIDRequiredConsistency']);
        }

        if (requestParameters['slashIDRequiredConsistencyTimeout'] != null) {
            headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters['slashIDRequiredConsistencyTimeout']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/oauth2/clients/{oauth_client_id}/ui-configuration`;
        urlPath = urlPath.replace('{oauth_client_id}', encodeURIComponent(String(requestParameters['oauthClientId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */
    async putOauth2UiConfigurationRaw(requestParameters: PutOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutOauth2UiConfiguration201Response>> {
        const requestOptions = await this.putOauth2UiConfigurationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutOauth2UiConfiguration201ResponseFromJSON(jsonValue));
    }

    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */
    async putOauth2UiConfiguration(requestParameters: PutOauth2UiConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutOauth2UiConfiguration201Response> {
        const response = await this.putOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
} as const;
export type PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum = typeof PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum[keyof typeof PutOauth2UiConfigurationSlashIDRequiredConsistencyEnum];
